export default `
    <div class="container" v-if="current != 'register' && current != 'login'">
        <div class="trueleafgs"><a :href="ajax_var.trueleaf_iframe_url"><img :src="ajax_var.base_uri + '/assets/images/logo-gstrueleaf-lg.png'" /></a></div>
        <div class="row justify-content-center">
            <div class="col-md-12" v-if="current != 'video'">
                <h3>{{ pages[current].topTitle }}</h3>
                <h1 v-html="pages[current].fieldLabel"></h1>
                <div class="welcome-content" v-if="current == 'welcome'">
                    <a class="btn btn-1 startButton" :href="startButtonLink">{{ startButtonLabel }}</a>
                    <a href="/" v-if="is_affiliate === false">< Back to Home</a>
                </div>
                <form @submit.prevent="next">
                    <div class="input-container" v-if="current != 'welcome'">
                        <div v-if="errorMessage" v-html="errorMessage" class="alert alert-danger" role="alert">

                        </div>
                        
                        <div v-bind:class="['subsMainInput', { 'focused': userData[current] || current === 'forgot' }]">
                            <label class="form-label" v-if="current != 'reset'" :for="(current != 'reset') ? pages[this.current].placeholder : ''">{{(current != 'reset') ? pages[this.current].placeholder : ''}}</label>
                            <input :disabled="loading" 
                                v-if="current != 'reset'" :value="(userData[current]) ? userData[current] : ''" 
                                :class="['dataInput', { 'passwordInput': current == 'reset_password' }]" 
                                :type="pages[current].fieldType" 
                            />
                            <i @click="togglePasswordLegacy" v-if="current == 'password' || current == 'reset_password'" class="far fa-eye fa-eye-slash" id="togglePassword"></i>
                        </div>
                        <div class="subsMainInput" v-if="current == 'password' || current == 'reset_password'">
                            <label class="form-label" for="confirmPassword">Confirm Password</label>
                            <input :disabled="loading" autocomplete="new-password" class="confirmPassword" type="password" />
                        </div>
                        <div v-if="current == 'reset'" class="gs_general_message">
                            <p>Thanks! If your email is in our database, you'll receive a link with instructions to reset your password to: </p>
                            <p><strong>{{ dataInput.value }}</strong>   </p>
                        </div>
                    </div>
                    <div class="subs_form_msge" v-if="pages[current].msge"><input type="checkbox" id="mailing_list_subs" @click="saveZipVal" v-model="mailingListCheck" true-value="1" false-value="false"> <span>{{ pages[current].msge }}</span></div>
                    <div class="form-subs-footer" v-if="current != 'welcome'" :class="{ footerEnd: !pages[this.current].prev }">
                        <a @click.prevent="back" href="#" v-if="pages[current].prev" class="backBtn">< Back</a>
                        <button v-if="pages[current].next" class="btn btn-1 input-step-btn" type="submit">
                            <span>{{ pages[current].btnLabel }} </span>
                            <i :class="{ hidden: !loading }" role="status" aria-hidden="true" class="fas fa-spinner fa-spin"></i>
                        </button>
                    </div>
                </form>
            </div>
            <div class="col-md-12 gs-video-row" v-if="current == 'video'">
                <h3>{{ pages[current].topTitle }}</h3>
                <div class="gs-video-container" :style="'background-image: url(' + ajax_var.base_uri + '/assets/images/video-background.jpg);'">
                    <div class="video-responsive">
                        <iframe width="788" height="440" src="https://www.youtube.com/embed/Oc34UIUJiZA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <img class="gs-garderner" :src="ajax_var.base_uri + '/assets/images/gardener.svg'" />
                    </div>
                </div>
                <a class="go-to-garden" href="https://hortisketch.gardensavvy.com/design">
                    <span>GO TO MY HORTISKETCH APP</span>
                    <img :src="ajax_var.base_uri + '/assets/images/shovel.svg'" />
                </a>
            </div>
        </div>
    </div>
`;
